import { isThereСlass } from '../common/help_functions';

export function header() {
  const header = document.querySelector('.header');
  const headerHumburger = document.querySelector('.header-hamburger');
  const sectionTopBanner = document.querySelector('.hero-type-1-section');
  const sectionContactBanner = document.querySelector('.contacts-hero-section');

  headerHumburger.addEventListener('click', () => {
    document.querySelector('body').classList.toggle('menu-open');
    document.querySelector('body').classList.toggle('overflow-hidden');
  })

  window.addEventListener('scroll', isHeaderSmall);
  document.addEventListener('DOMContentLoaded', isHeaderSmall);

  function isHeaderSmall() {
    const scroll = window.scrollY;
    (scroll > 50) ? header.classList.add('small') : header.classList.remove('small');
  }

  if (isThereСlass('.hero-type-1-section')) {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY;
      (scroll > 50) ? sectionTopBanner.classList.add('remove-margins') : sectionTopBanner.classList.remove('remove-margins');
    });
  }

  if (isThereСlass('.contacts-hero-section')) {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY;
      (scroll > 50) ? sectionTopBanner.classList.add('remove-margins') : sectionTopBanner.classList.remove('remove-margins');
    });
  }
}
